import React from 'react';

const ENGINE_ID = '36629822e234c4b5e';

function loadPseScriptOnce() {
    return new Promise((resolve, reject) => {
        // If already loaded, resolve immediately
        if (window.google && window.google.search && window.google.search.cse) {
            resolve();
            return;
        }

        // If script tag already exists, wait for it to finish
        const existing = document.querySelector('script[data-pse="true"]');
        if (existing) {
            existing.addEventListener('load', () => resolve(), { once: true });
            existing.addEventListener('error', () => reject(new Error('PSE script failed to load')), { once: true });
            return;
        }

        const s = document.createElement('script');
        s.async = true;
        s.src = `https://cse.google.com/cse.js?cx=${ENGINE_ID}`;
        s.setAttribute('data-pse', 'true');
        s.addEventListener('load', () => resolve(), { once: true });
        s.addEventListener('error', () => reject(new Error('PSE script failed to load')), { once: true });
        document.head.appendChild(s);
    });
}

export default function Page() {
    const containerRef = React.useRef(null);
    const [status, setStatus] = React.useState('loading'); // loading | ready | error

    React.useEffect(() => {
        let cancelled = false;

        async function init() {
            try {
                setStatus('loading');

                // Ensure container exists in DOM
                if (!containerRef.current) return;

                // Clear any previous leftover markup (helps when revisiting route)
                containerRef.current.innerHTML = '';

                // Create the widget div fresh
                const widget = document.createElement('div');
                widget.className = 'gcse-search';
                containerRef.current.appendChild(widget);

                // Load script once
                await loadPseScriptOnce();

                // Give Google a tiny breath to attach globals consistently
                // (yes this is silly, yes it helps sometimes)
                await new Promise(r => setTimeout(r, 0));

                if (cancelled) return;

                // If the google.cse API is present, force a render
                if (window.google && window.google.search && window.google.search.cse && window.google.search.cse.element) {
                    try {
                        window.google.search.cse.element.render(
                            {
                                div: widget,
                                tag: 'search'
                            }
                        );
                    } catch (e) {
                        // If render fails, fallback to letting auto-render try
                        // (no-op)
                    }
                }

                setStatus('ready');
            } catch (e) {
                if (!cancelled) setStatus('error');
            }
        }

        init();

        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <div style={{ padding: 5 }}>
            {/* Optional: helpful when it silently fails */}
            {status === 'error' && (
                <div style={{ marginBottom: 12 }}>
                    Search failed to load. Try disabling ad blockers for this page.
                </div>
            )}

            <div ref={containerRef} />
        </div>
    );
}
